<template>
  <v-container fluid tag="section">
    <div  v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-expansion-panels>
      <v-expansion-panel v-for="(item,i) in item" :key="i">
        <v-expansion-panel-header>
          <v-row>
            <v-col cols="12" md='2'>{{item.serialNumber}}</v-col>
            <v-col cols="12" md='1' v-if="showPrice(item.contactsPersonList)">合同:&nbsp;¥{{item.signPrice}}</v-col>
            <v-col cols="12" md='1' v-if="showPrice(item.contactsPersonList)">开票:&nbsp;¥{{item.invoiceInfos | fmPrice}}</v-col>
            <v-col cols="12" md='1' v-if="showPrice(item.contactsPersonList)" >已收:&nbsp;¥{{item.returnedMoneys | fmPrice}}</v-col>
            <v-col cols="12" md='6'>{{item.product.name}}</v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <contract-view :mini='mini' :item='item' lazy></contract-view>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import { getById } from '@/api/contract/index.js'

  export default {
    name: 'CustomerContractsDetail',
    components: {
      ContractView
    },
    filters: {
      fmPrice (item) {
        let money = 0
        item.forEach(el => {
          if (el.order.auditStatus === 1) {
            money += el.money
          }
        })
        return money
      }
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    methods: {
      loadData (id) {
        this.loading = true
        getById(id).then(res => {
          if (res.status === 200) {
            this.data = res.data
          }
          this.loading = false
        })
      },
      showPrice (list) {
        let boo = false
        list.forEach(p => {
          boo = p.id === this.$store.state.userInfo.id
        });
        return boo || this.$_has('con-contract-price') || this.$store.state.userInfo.roleIds.indexOf(1) !== -1
      },
    }
  }
</script>

<style>
</style>
